import { normalizeHexColor } from "../types/eegViewerTraceTypes";

export type ViewerMontageDraftPair = {
  positive: string;
  negative: string;
  label: string;
  color?: string;
};

export function defaultMontagePairLabel(pair: {
  positive?: string;
  negative?: string;
}): string {
  const positive = (pair.positive || "").trim();
  const negative = (pair.negative || "").trim();
  if (!positive && !negative) return "New Pair";
  if (!negative) return positive;
  return `${positive}-${negative}`;
}

export function normalizeMontageDraftPair(
  pair: {
    positive?: string;
    negative?: string;
    label?: string;
    color?: string;
  },
  fallbackIndex: number,
): ViewerMontageDraftPair {
  const positive = (pair.positive || "").trim();
  const negative = (pair.negative || "").trim();
  const fallbackLabel = defaultMontagePairLabel({ positive, negative });
  return {
    positive,
    negative,
    label:
      (pair.label || "").trim() ||
      `${fallbackLabel || "Pair"} ${fallbackIndex + 1}`.trim(),
    ...(normalizeHexColor(pair.color)
      ? { color: normalizeHexColor(pair.color)! }
      : {}),
  };
}
